var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreventative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1758_22407)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.833313 3.33325C0.833313 1.95254 1.9526 0.833252 3.33331 0.833252H3.95831C4.41855 0.833252 4.79165 1.20635 4.79165 1.66659C4.79165 2.12682 4.41855 2.49992 3.95831 2.49992H3.33331C2.87308 2.49992 2.49998 2.87302 2.49998 3.33325V7.49992C2.49998 9.80109 4.36546 11.6666 6.66665 11.6666C8.96781 11.6666 10.8333 9.80109 10.8333 7.49992V3.33325C10.8333 2.87302 10.4602 2.49992 9.99998 2.49992H9.37498C8.91473 2.49992 8.54165 2.12682 8.54165 1.66659C8.54165 1.20635 8.91473 0.833252 9.37498 0.833252H9.99998C11.3807 0.833252 12.5 1.95254 12.5 3.33325V7.49992C12.5 10.4387 10.3269 12.8698 7.49998 13.2742V13.3333C7.49998 15.6344 9.36548 17.4999 11.6666 17.4999C13.9678 17.4999 15.8333 15.6344 15.8333 13.3333V11.5243C14.8623 11.1812 14.1666 10.2551 14.1666 9.16659C14.1666 7.78588 15.2859 6.66659 16.6666 6.66659C18.0474 6.66659 19.1666 7.78588 19.1666 9.16659C19.1666 10.2551 18.471 11.1812 17.5 11.5243V13.3333C17.5 16.5549 14.8883 19.1666 11.6666 19.1666C8.44498 19.1666 5.83331 16.5549 5.83331 13.3333V13.2742C3.0064 12.8698 0.833313 10.4387 0.833313 7.49992V3.33325ZM16.6666 9.99992C17.1269 9.99992 17.5 9.62684 17.5 9.16659C17.5 8.70634 17.1269 8.33325 16.6666 8.33325C16.2064 8.33325 15.8333 8.70634 15.8333 9.16659C15.8333 9.62684 16.2064 9.99992 16.6666 9.99992Z",
    fill: "#201F20"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1758_22407"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreventative);
export default __webpack_public_path__ + "static/media/preventative.ab3abf328fab017a24f5bccbbb024aae.svg";
export { ForwardRef as ReactComponent };